<template>
  <div class="loading-screen" :class="{ show: show }">
    <div class="loading-icon-container">
      <LoadingIcon size="large" colour1="black" colour2="white"/>
    </div>
    <!-- <alert v-if="loadingTimeout" @cancel="cancel" @refresh="refresh" >
      <slot>
        <div class="alert-content">
          <div class="information-circle">
          <p>i</p>
        </div>
        <div>
          <p>Oops. Something went wrong.</p>
          <p>Please Refresh.</p>
        </div>
        </div>
      </slot>
    </alert> -->
  </div>
</template>
<script>
// import Alert from '@/components/global/popups/Alert.vue'
import LoadingIcon from '@/components/global/loading/LoadingIcon.vue'

export default {
  name: 'LoadingScreen',
  components: {
    LoadingIcon
  },
  data() {
    return {
      show: false,
      loadingTimeout: false
    };
  },
  // components: {
  //   Alert
  // },
  methods: {
    loadingRefresh() {
      setTimeout(() => {
        this.loadingTimeout = true;
      }, 5000);
    },
    cancel() {
      this.loadingTimeout = false;
    },
    refresh() {
      if (this.loadingTimeout) {
        window.location.reload();
      }
    }
  },
  mounted() {
    this.loadingRefresh();
  },
  beforeDestroy() {
    clearTimeout(this.loadingRefresh());
  }
};
</script>
<style lang="scss" scoped>
@import '~@/scss/components/global/loading/loading_screen.scss';
</style>
